module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Play-88244368a58f56ae3789294db0cf36f8.svg";